<!-- admin-panel.component.html -->
<div class="admin-wrapper">
  <!-- Mobile Overlay -->
  <div
    class="mobile-overlay"
    [class.show]="isSidebarCollapsed && isMobile"
    (click)="toggleSidebar()"
  ></div>

  <!-- Sidebar -->
  <nav
    class="sidebar"
    [class.collapsed]="isSidebarCollapsed && !isMobile"
    [class.show]="isSidebarCollapsed && isMobile"
  >
    <div class="sidebar-header">
      <a href="#" class="sidebar-brand">
        <i class="fas fa-cube"></i>
        <span>MV Backoffice</span>
      </a>
    </div>
    <div class="sidebar-nav">
      <!--
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR'">
        <a
          routerLink="home"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </a>
      </div>
      -->
      
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR' || environment.currentUser.userProfiles[0].profile === 'AGENCY'">
        <a
          routerLink="users"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-users"></i>
          <span>Users</span>
        </a>
      </div>
      
      <div class="nav-item">
        <a
          routerLink="reservations"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-shopping-cart"></i>
          <span>Reservations</span>
        </a>
      </div>
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR' || environment.currentUser.userProfiles[0].profile === 'TM_OPERATOR'">
        <a
          routerLink="agencies"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-building"></i>
          <span>Agency</span>
        </a>
      </div>
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'AGENCY' || environment.currentUser.userProfiles[0].profile === 'TM_OPERATOR'">
        <a
          [routerLink]="`users/update/${environment.currentUser.userId}`"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-building"></i>
          <span>Profile</span>
        </a>
      </div>
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR' || environment.currentUser.userProfiles[0].profile === 'AGENCY' || environment.currentUser.userProfiles[0].profile === 'TM_OPERATOR'">
        <a
          routerLink="deposits"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-money-bill-transfer"></i>
          <span>Deposits</span>
        </a>
      </div>
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR'">
        <a
          routerLink="deposit-mv"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-money-bill-transfer"></i>
          <span>Deposit MV</span>
        </a>
      </div>
      <div class="nav-item" *ngIf="environment.currentUser.userProfiles[0].profile === 'ADMINISTRATOR' || environment.currentUser.userProfiles[0].profile === 'TM_OPERATOR'">
        <a
          routerLink="availability"
          routerLinkActive="active"
          class="nav-link"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-ticket"></i>
          <span>Availability</span>
        </a>
        </div>
    </div>
  </nav>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Header -->
    <header class="header">
      <div class="header-left">
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <i class="fas fa-bars"></i>
        </button>
        <!--
        <div class="search-box">
          <input
            type="text"
            placeholder="Search..."
            (keyup.enter)="onSearch()"
          />
          <i class="fas fa-search"></i>
        </div>
        -->
      </div>
      <div class="header-right">
        <!-- Notifications Dropdown -->
        <!--
        <div class="notification-dropdown" ngbDropdown>
          <div class="header-icon" ngbDropdownToggle>
            <i class="fas fa-bell"></i>
            <span class="notification-badge" *ngIf="unreadCount > 0">{{
              unreadCount
            }}</span>
          </div>
          <div class="notification-panel" ngbDropdownMenu>
            <div class="notification-header">
              <h3 class="notification-title">Notifications</h3>
              <a
                href="#"
                class="mark-all-read"
                (click)="markAllAsRead(); $event.preventDefault()"
              >
                Mark all as read
              </a>
            </div>
            <div class="notification-list">
              <div
                class="notification-item"
                *ngFor="let notification of notifications"
                [class.unread]="notification.unread"
                (click)="markNotificationAsRead(notification)"
              >
                <div class="notification-icon" [class]="notification.type">
                  <i [class]="notification.icon"></i>
                </div>
                <div class="notification-content">
                  <p class="notification-message">{{ notification.message }}</p>
                  <span class="notification-time">{{ notification.time }}</span>
                </div>
              </div>
            </div>
            <div class="notification-footer">
              <a href="#" class="view-all-notifications"
                >View all notifications</a
              >
            </div>
          </div>
        </div>

        <div class="header-icon">
          <i class="fas fa-envelope"></i>
        </div>
-->
        <!-- Profile Dropdown -->
        <div class="profile-dropdown" ngbDropdown>
          <img
            src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face&auto=format"
            alt="Profile"
            class="profile-avatar"
            ngbDropdownToggle
          />
          <div class="dropdown-menu" ngbDropdownMenu>            
            <div class="dropdown-status-profile">
              <p>{{environment.currentUser.userProfiles[0].profile}}</p>
              <p class="sub-pa fw-bold">{{environment.currentUser.email}}</p>
            </div>
            <a class="dropdown-item"  [routerLink]="`users/update/${environment.currentUser.userId}`">
              <i class="fas fa-user"></i>
              <span>Profile</span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="onLogout()">
              <i class="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </a>
          </div>
        </div>
      </div>
    </header>

    <!-- Content -->
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
